import { http, HttpResponse, delay } from "msw";

const items = [
    {
        "id": "e836bb26-21ba-4238-826d-aa3680cc09e5",
        "supplier_id": "3c180f6a-681a-4a8a-807e-029dcaf55ba7",
        "supplier_name": "Distribuidora Mecánica MX",
        "type": "product",
        "name": "Aceite 5W-30 Sintético 1L",
        "sku": "OIL-5W30-1L",
        "stock": "0.00",
        "cost_price": "110.00",
        "sale_price": "180.00"
    },
    {
        "id": "2ada71e7-4e44-4c5f-91e2-8d7b24b2f4e8",
        "supplier_id": "b46e7372-0c52-41ad-b0c9-8c2c96e797e7",
        "supplier_name": "Refacciones González",
        "type": "product",
        "name": "Bujía NGK BKR6E",
        "sku": "NGK-BKR6E",
        "stock": "120.00",
        "cost_price": "45.00",
        "sale_price": "80.00"
    },
    {
        "id": "e11d82b4-c151-49b1-b5e2-f7a5b4e316e5",
        "supplier_id": null,
        "supplier_name": null,
        "type": "service",
        "name": "Cambio de aceite",
        "sku": null,
        "stock": null,
        "cost_price": "0.00",
        "sale_price": "350.00"
    },
    {
        "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
        "supplier_id": "f7f1b239-77c8-4fa1-88d6-3174596813e5",
        "supplier_name": "Auto Partes del Norte",
        "type": "product",
        "name": "Filtro de aceite FRAM PH3387A",
        "sku": "FRAM-PH3387A",
        "stock": "50.00",
        "cost_price": "85.00",
        "sale_price": "140.00"
    }
];

const saleItems = [
    {
        "id": "e836bb26-21ba-4238-826d-aa3680cc09e5",
        "supplier_id": "3c180f6a-681a-4a8a-807e-029dcaf55ba7",
        "supplier_name": "Distribuidora Mecánica MX",
        "type": "product",
        "name": "Aceite 5W-30 Sintético 1L",
        "sku": "OIL-5W30-1L",
        "stock": "0.00",
        "cost_price": "110.00",
        "sale_price": "180.00"
    },
    {
        "id": "2ada71e7-4e44-4c5f-91e2-8d7b24b2f4e8",
        "supplier_id": "b46e7372-0c52-41ad-b0c9-8c2c96e797e7",
        "supplier_name": "Refacciones González",
        "type": "product",
        "name": "Bujía NGK BKR6E",
        "sku": "NGK-BKR6E",
        "stock": "120.00",
        "cost_price": "45.00",
        "sale_price": "80.00"
    },
    {
        "id": "e11d82b4-c151-49b1-b5e2-f7a5b4e316e5",
        "supplier_id": null,
        "supplier_name": null,
        "type": "service",
        "name": "Cambio de aceite",
        "sku": null,
        "stock": null,
        "cost_price": "0.00",
        "sale_price": "350.00"
    },
    {
        "id": "c31aaa07-a893-4bcf-b072-9145601290fc",
        "supplier_id": "f7f1b239-77c8-4fa1-88d6-3174596813e5",
        "supplier_name": "Auto Partes del Norte",
        "type": "product",
        "name": "Filtro de aceite FRAM PH3387A",
        "sku": "FRAM-PH3387A",
        "stock": "50.00",
        "cost_price": "85.00",
        "sale_price": "140.00"
    }
];

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_STAGE_ENV}/items`

export const itemsHandlers = [
    http.get(`${baseUrl}`, async ({ request }) => {
        await delay(2100);

        return HttpResponse.json(
            items,
            { status: 200 }
        );
    }),
    http.get(`${baseUrl}/sale`, async ({ request }) => {
        await delay(2100);

        return HttpResponse.json(
            items,
            { status: 200 }
        );
    }),
    http.post(`${baseUrl}`, async ({ request }) => {
        const { supplier_id, type, name, sku, stock, cost_price, sale_price } = await request.json();
        const newItem = {
            id: "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            name,
            supplier_id,
            type,
            sku,
            stock,
            cost_price,
            sale_price
        }
        items.push(newItem)

        await delay(800);

        return HttpResponse.json(
            newItem,
            { status: 200 }
        );
    }),
    http.put(`${baseUrl}`, async ({ request }) => {
        const { id, supplier_id, type, name, sku, stock, cost_price, sale_price } = await request.json();
        let idx = items.findIndex(item => item.id === id);
        items[idx] = { id, supplier_id, type, name, sku, stock, cost_price, sale_price }
        await delay(800);

        return HttpResponse.json(
            items.find(item => item.id === id),
            { status: 200 }
        );
    }),
    http.delete(`${baseUrl}/:id`, async ({ params }) => {
        const { id } = params;

        const index = items.findIndex(c => c.id === id);

        if (index === -1) {
            return HttpResponse.json(
                { message: 'Item not found' },
                { status: 404 }
            );
        }

        const deletedItem = items[index];
        items.splice(index, 1);

        await delay(800);

        return HttpResponse.json(
            deletedItem,
            { status: 200 }
        );
    })
];
